import type { PropsWithChildren } from 'react';
import { useTranslation } from 'translations/hooks';

export const ScanSquare = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();

  return (
    <div className="relative rounded-lg bg-blue-200 px-6 py-2 text-center">
      <p className="text-primary pb-2">{t('common.scanSquareMessage')}</p>
      {children}
    </div>
  );
};
